import React from 'react';
import Window from '../os/Window';

export interface CreditsProps extends WindowAppProps {}

const OG_LINK = 'https://github.com/henryjeff/portfolio-website';

const ASSETS: { name: string; creator: string; url: string }[] = [
    { name: 'Carpet', creator: 'polybean', url: 'https://sketchfab.com/3d-models/carpet-fluffy-435d64ef1e36457790000c6b6aa4b8b2' },
    { name: 'Plant', creator: 'AllQuad', url: 'https://sketchfab.com/3d-models/free-dyspis-lutescens-potted-palm-92f75abd656049608248cf76a8c88136' },
    { name: 'Chair', creator: 'ROY', url: 'https://sketchfab.com/3d-models/chair-futuristic-chair-22af0922da29411b95ea1e1be99ecd46' },
    { name: 'Desk', creator: 'mrfurrer', url: 'https://sketchfab.com/3d-models/desk-86aeb68defa1461da9db2b529493515c' },
    { name: 'Chess', creator: 'Gipfelgrmpf', url: 'https://sketchfab.com/3d-models/star-trek-chess-43fc53039ef6420f9e745bdca14dd39e' },
    { name: 'Paper pile', creator: 'dev.mansaf', url: 'https://sketchfab.com/3d-models/pile-of-papers-1c869363f677412aaafe0acc777b1392' },
    { name: 'Cube', creator: 'FromSi', url: 'https://sketchfab.com/3d-models/rubiks-cube-4cc7c1bf585f4b929ddd32f6cab3ba58' },
    { name: 'Boat', creator: 'fuglee', url: 'https://sketchfab.com/3d-models/paper-boat-927906c2044745ea94055f99b11e8981' },
    { name: 'MacBook Pro', creator: 'Apple User', url: 'https://sketchfab.com/3d-models/macbook-pro-14-inch-m5-652a992f4f244122ae251f9cbb81da1e' },
    { name: 'iPad', creator: 'eltayerkebulan', url: 'https://sketchfab.com/3d-models/apple-pencil-ipad-pro-405089fc7b7d4509a6e1d35b185db384' },
    { name: 'Pen Holder', creator: 'Peia_Tenshin', url: 'https://sketchfab.com/3d-models/pen-holder-d3cf169e862449f68ede07ed53958b6b' },
    { name: 'Mug', creator: 'The Lister', url: 'https://sketchfab.com/3d-models/coffee-mug-6c95897de04143aeb5c75b7630707d27' },
    { name: 'Lamp', creator: 'kelseysmith1028', url: 'https://sketchfab.com/3d-models/modern-black-table-lamp-eb5bdce013e2406ca66404325589f15d' },
];

const Credits: React.FC<CreditsProps> = (props) => {
    return (
        <Window
            top={48}
            left={48}
            width={520}
            height={560}
            windowTitle="Credits"
            windowBarIcon="credits"
            closeWindow={props.onClose}
            onInteract={props.onInteract}
            minimizeWindow={props.onMinimize}
            bottomLeftText="© Filips Juzilins (Phil)"
        >
            <div style={styles.scroll}>
                <div style={styles.section}>Modeling & Texturing</div>
                <div style={styles.line}>Original author - Texturing, Composition, & UV</div>
                <div style={styles.line}>Mickael Boitte - Computer Model</div>
                <div style={styles.line}>Sean Nicolas - Environment Models</div>
                <div style={styles.line} />
                <div style={styles.section}>Sound Design</div>
                <div style={styles.line}>Original author - Mixing, Composition, & Foley</div>
                <div style={styles.line}>Sound Cassette - Office Ambience</div>
                <div style={styles.line}>Windows 95 Startup Sound - Microsoft</div>
                <div style={styles.line}>
                    Lofi Girl - Lofi jazz music - <a href="https://www.youtube.com/watch?v=-R0UYHS8A_A&list=RD-R0UYHS8A_A&index=1" target="_blank" rel="noopener noreferrer" style={styles.link}>youtube.com</a>
                </div>
                <div style={styles.line} />
                <div style={styles.section}>Special thanks</div>
                <div style={styles.line}>Bruno Simon</div>
                <div style={styles.line}>Lorelei Kravinsky</div>
                <div style={styles.line}>Trey Briccetti</div>
                <div style={styles.line}>SimonDev</div>
                <div style={styles.line}>Scott Bass</div>
                <div style={styles.line}>Mom, Dad & Angela</div>
                <div style={styles.line} />
                <div style={styles.section}>Inspiration</div>
                <div style={styles.line}>Bruno Simon, Pink Yellow, Jesse Zhou, Vivek Patel</div>
                <div style={styles.line} />
                <div style={styles.lineHighlight}>
                    Henry Heffernan - main inspiration <a href={OG_LINK} target="_blank" rel="noopener noreferrer" style={styles.link}>{OG_LINK}</a>
                </div>
                <div style={styles.line} />
                <div style={styles.line}>Current: Filips Juzilins (Phil) - code & experience.</div>
                <div style={styles.line} />
                <div style={styles.section}>3D assets (Sketchfab)</div>
                {ASSETS.map(({ name, creator, url }) => (
                    <div key={name} style={styles.line}>
                        {name} - {creator} - <a href={url} target="_blank" rel="noopener noreferrer" style={styles.link}>{url}</a>
                    </div>
                ))}
            </div>
        </Window>
    );
};

const styles: StyleSheetCSS = {
    scroll: {
        flex: 1,
        minHeight: 0,
        padding: 16,
        overflowY: 'auto',
        overflowX: 'hidden',
        fontFamily: 'SF Mono, Monaco, "Courier New", monospace',
        fontSize: 12,
        color: '#e8e8e8',
        lineHeight: 1.7,
        userSelect: 'text',
        WebkitUserSelect: 'text',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        display: 'block',
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
    },
    section: {
        marginTop: 10,
        marginBottom: 4,
        fontWeight: 600,
        color: 'rgba(255, 255, 255, 0.9)',
    },
    line: {
        marginBottom: 6,
        display: 'block',
        width: '100%',
    },
    lineHighlight: {
        marginBottom: 6,
        display: 'block',
        width: '100%',
        fontSize: 13,
        fontWeight: 600,
        color: '#e8e8e8',
    },
    link: {
        color: '#7eb8ff',
        textDecoration: 'underline',
    },
};

export default Credits;
